/** Navegação dentro da gestão (sem recarregar): o Backoffice ouve o popstate. */
export function navigate(path: string) {
  history.pushState({}, '', path);
  dispatchEvent(new PopStateEvent('popstate'));
}
